import { clientWithCredentials } from "../_helpers";
import { systemConstants, alertConstants } from "../_constants";

export const systemAction = {
    editSystem,
    createSystem
};

function editSystem(data: any) {
    return function(dispatch: any) {
        dispatch({
            type: systemConstants.SYSTEM_EDIT
        });
        clientWithCredentials(dispatch).post("api/system", data)
        .then( dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: "system_edited",
                        level: "notification"
                    }
                })
            )
            .catch((error) => {
                dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: error.message,
                        level: "error"
                    }
                });
            })

    }
}

function createSystem(data: any) {
    return function(dispatch: any) {
        dispatch({
            type: systemConstants.SYSTEM_CREATE
        });
        clientWithCredentials(dispatch).put("api/system", data)
        .then( dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: "system_created.",
                        level: "notification"
                    }
                })
            )

            .catch((error) => {
                dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: error.response ? ( error.response.data ? error.response.data[0] : error ) : error,
                        level: "error"
                    }
                });
            })
    }
}